import { ReactSVG } from "react-svg";
import { formatCurrency, transformDateToLocalDateString } from "helpers";
import { FleetVehicleExpense } from "services/api/fleet/vehicles/expenses/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

/**
 * Stupci popisa troškova unesenih u čarobnjaku premještaja. Uklanjanje briše trošak,
 * jer je modal već stvorio zapis.
 */
export const VEHICLE_TRANSFER_EXPENSE_COLUMNS = (
  onRemoveClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "Vrsta",
    key: "transfer_expense_type",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleExpense) => (
      <div className="text-sm text-slate-500 truncate">
        {row.expenseTypeName ?? "-"}
      </div>
    ),
  },
  {
    title: "Naziv",
    key: "transfer_expense_name",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleExpense) => (
      <div className="text-md font-medium text-slate-600 truncate">{row.name}</div>
    ),
  },
  {
    title: "Opis",
    key: "transfer_expense_description",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleExpense) => (
      <div className="text-sm text-slate-900 truncate max-w-[260px]">
        {row.description || "-"}
      </div>
    ),
  },
  {
    title: "Datum",
    key: "transfer_expense_date",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleExpense) => (
      <div className="text-sm text-slate-500">
        {row.expenseDate ? transformDateToLocalDateString(new Date(row.expenseDate)) : "-"}
      </div>
    ),
  },
  {
    title: "Iznos",
    key: "transfer_expense_amount",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleExpense) => (
      <div className="text-sm font-medium text-slate-900">
        {formatCurrency.format(row.amount ?? 0)}
      </div>
    ),
  },
  {
    title: "",
    key: "transfer_expense_remove",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleExpense) => (
      <div
        onClick={(event) => onRemoveClick(event, row.id)}
        className="flex justify-end items-center h-[30px]"
      >
        <ReactSVG
          src={"/media/icons/trash.svg"}
          className="w-4 h-4 stroke-[#bd0000]"
        />
      </div>
    ),
  },
];
